import _ from 'underscore';
import React, { useCallback, useContext, useMemo } from 'react';
import { useConfirmDialog } from '@bingads-webui-campaign-react/common-hooks';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { CancelDialogContent } from './cancel-dialog-content';

export function useCouponPromptCancelDialog(props) {
  const {
    uiActivity,
    couponDetails = {},
    handleConfirmDialog = _.noop,
    couponPlatformText,
    titleText,
    descriptionText,
    confirmButtonText,
    getCouponCurrencyCode = _.noop,
  } = props;
  const serverContext = useContext(ServerContext);
  const i18n = useContext(I18nContext);

  const handleCancelDialog = useCallback(() => {
    const {
      Urls: {
        SignOutUrl = null,
      } = {},
    } = serverContext;

    uiActivity.trace(`[Coupon Prompt]: Sign out via CouponPromptCancelDialog: ${SignOutUrl}`);
    if (SignOutUrl) {
      window.location.href = SignOutUrl;
    }
  }, [serverContext, uiActivity]);

  const handleDismissDialog = useCallback(() => {
    uiActivity.trace('[Coupon Prompt]: Dismiss CouponPromptCancelDialog');
  }, [uiActivity]);

  const content = useMemo(() => (
    <CancelDialogContent
      couponDetails={couponDetails}
      couponPlatformText={couponPlatformText}
      descriptionText={descriptionText}
      getCouponCurrencyCode={getCouponCurrencyCode}
    />
  ), [couponDetails, couponPlatformText, descriptionText, getCouponCurrencyCode]);

  const cancelButtonText = i18n.getString(_TL_('No, thanks—Exit now'));

  return useConfirmDialog({
    title: titleText || i18n.getString(_TL_('Complete your setup and get {{ couponText }} off!')),
    content,
    confirmText: confirmButtonText || i18n.getString(_TL_('Continue setup')),
    onConfirm: handleConfirmDialog,
    onCancel: handleCancelDialog,
    onDismiss: handleDismissDialog,
    cancelText: cancelButtonText,
    className: 'coupon-prompt-cancel-dialog',
  }, {
    activity: uiActivity,
    dialogName: 'CouponPromptCancelDialog',
  });
}
